export enum HomePageSection {
  Banner = "banner",
  Intro = "intro",
  Selected = "selected",
  Offer = "offer",
  Author = "author",
}
